import { IQuestion } from '../interfaces/questionnaire';
import { IEquivalencia } from '../interfaces/equivalence';
import api from './api';

export interface CreateQuestionData {
  pergunta: string;
  dominio_id: number;
  is_modelo: boolean;
  tipo_resposta: 'TEXTO_LIVRE' | 'MULTIPLA_ESCOLHA' | 'SIM_NAO' | 'PERCENTUAL';
  opcoes?: string[]; // Array de strings, não objetos
  tipo_documento?: string;
  documento?: string;
  framework?: string;
  dominio_controle?: string;
}

export interface UpdateQuestionData extends Omit<CreateQuestionData, 'is_modelo'> {
  id: number;
}

class QuestionService {
  async getAll(): Promise<IQuestion[]> {
    const response = await api.getQuestions();
    return response.success ? (response.data as IQuestion[]) : [];
  }

  async getById(id: number): Promise<IQuestion | null> {
    const response = await api.getQuestion(id);
    return response.success ? (response.data as IQuestion) : null;
  }

  async create(questionData: CreateQuestionData): Promise<IQuestion | null> {
    const response = await api.createQuestion(questionData);
    return response.success ? (response.data as IQuestion) : null;
  }

  async update(id: number, questionData: UpdateQuestionData): Promise<IQuestion | null> {
    const response = await api.updateQuestion(id, questionData);
    return response.success ? (response.data as IQuestion) : null;
  }

  async delete(id: number): Promise<boolean> {
    const response = await api.deleteQuestion(id);
    return response.success;
  }

  async createEquivalence(pergunta_id_1: number, pergunta_id_2: number): Promise<boolean> {
    const response = await api.createEquivalence({
      pergunta_id_1,
      pergunta_id_2
    });
    return response.success;
  }

  async getEquivalences(): Promise<IEquivalencia[]> {
    const response = await api.getEquivalencias();
    return response.success ? (response.data as IEquivalencia[]) : [];
  }
}

export const questionService = new QuestionService();

export {};